const supabaseConf = {
  supabaseUrl: "https://ncrgvxrwqponddwexajp.supabase.co",
  supabaseKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5jcmd2eHJ3cXBvbmRkd2V4YWpwIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODMxOTY3NjcsImV4cCI6MTk5ODc3Mjc2N30.qyRo5TwBypL_fb2CHcGpSzfWEkMaRo-byJQFCktaRQM"
};

export default supabaseConf;
